import { render } from "./DragonSignalBacktest.vue?vue&type=template&id=8d424624&scoped=true&ts=true"
import script from "./DragonSignalBacktest.vue?vue&type=script&lang=ts"
export * from "./DragonSignalBacktest.vue?vue&type=script&lang=ts"

import "./DragonSignalBacktest.vue?vue&type=style&index=0&id=8d424624&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d424624"]])

export default __exports__